import {useCallback, useEffect, useRef} from "react";
import {useHistory, useLocation} from "react-router-dom";

/** `location.state` key of the history entry pushed while the mobile layer is open. */
export const PRICES_SEARCH_LAYER_HISTORY_STATE_KEY = "pricesSearchLayer";

const hasLayerMarker = (state: unknown): boolean =>
    typeof state === "object" && state !== null && (state as Record<string, unknown>)[PRICES_SEARCH_LAYER_HISTORY_STATE_KEY] === true;

export interface IUsePricesSearchLayerHistoryOptions {
    isOpen: boolean;
    /** The layer has to close: the user went back (Android back, browser back) past the entry of the open layer. */
    onClose: () => void;
}

export interface IUsePricesSearchLayerHistoryResult {
    /** ← and Esc: closes the layer and takes the entry pushed for it off the history. */
    close: () => void;
    /** Leaves the page for "href". From the layer's own entry the destination replaces that entry, so Back returns to the page as it was before the layer. */
    leave: (href: string) => void;
}

/**
 * The open mobile layer is one history entry, so the system back gesture closes it instead of leaving the
 * page. Opening pushes the current location with a state marker (same path and query - the route data fetcher does
 * not run), closing from the layer goes back over it, and a location without the marker (back pressed) closes it.
 */
export const usePricesSearchLayerHistory = (options: IUsePricesSearchLayerHistoryOptions): IUsePricesSearchLayerHistoryResult => {
    const {isOpen} = options;
    const history = useHistory();
    const location = useLocation();

    // The layer's own entry is the current one: pushed by this hook and not yet left.
    const isOnLayerEntryRef = useRef(false);
    const isPushedRef = useRef(false);
    const isOpenRef = useRef(isOpen);
    const onCloseRef = useRef(options.onClose);

    useEffect(() => {
        isOpenRef.current = isOpen;
        onCloseRef.current = options.onClose;
    });

    useEffect(() => {
        if (!isOpen || isPushedRef.current) {
            return;
        }

        isPushedRef.current = true;
        const {location: current} = history;
        const state = typeof current.state === "object" && current.state !== null ? current.state : {};
        history.push({...current, state: {...state, [PRICES_SEARCH_LAYER_HISTORY_STATE_KEY]: true}});
    }, [isOpen, history]);

    useEffect(() => {
        // An entry with the marker that this page did not push (a reload of it) is not the layer's.
        if (hasLayerMarker(location.state)) {
            isOnLayerEntryRef.current = isPushedRef.current;
            return;
        }

        if (!isOnLayerEntryRef.current) {
            return;
        }

        // Left the layer's entry: back was pressed, or `close` went back.
        isOnLayerEntryRef.current = false;
        isPushedRef.current = false;
        if (isOpenRef.current) {
            onCloseRef.current();
        }
    }, [location]);

    const close = useCallback(() => {
        onCloseRef.current();

        if (!isPushedRef.current) {
            return;
        }

        // Forgotten first, so the location change `goBack` causes is not taken for a back press.
        isPushedRef.current = false;
        isOnLayerEntryRef.current = false;
        if (hasLayerMarker(history.location.state)) {
            history.goBack();
        }
    }, [history]);

    const leave = useCallback(
        (href: string) => {
            if (isPushedRef.current && hasLayerMarker(history.location.state)) {
                window.location.replace(href);
                return;
            }

            window.location.assign(href);
        },
        [history]
    );

    return {close, leave};
};
import {useCallback, useEffect, useRef} from "react";
import {useHistory, useLocation} from "react-router-dom";

/** `location.state` key of the history entry pushed while the mobile layer is open. */
export const PRICES_SEARCH_LAYER_HISTORY_STATE_KEY = "pricesSearchLayer";

const hasLayerMarker = (state: unknown): boolean =>
    typeof state === "object" && state !== null && (state as Record<string, unknown>)[PRICES_SEARCH_LAYER_HISTORY_STATE_KEY] === true;

export interface IUsePricesSearchLayerHistoryOptions {
    isOpen: boolean;
    /** The layer has to close: the user went back (Android back, browser back) past the entry of the open layer. */
    onClose: () => void;
}

export interface IUsePricesSearchLayerHistoryResult {
    /** ← and Esc: closes the layer and takes the entry pushed for it off the history. */
    close: () => void;
    /** Leaves the page for "href". From the layer's own entry the destination replaces that entry, so Back returns to the page as it was before the layer. */
    leave: (href: string) => void;
}

/**
 * The open mobile layer is one history entry, so the system back gesture closes it instead of leaving the
 * page. Opening pushes the current location with a state marker (same path and query - the route data fetcher does
 * not run), closing from the layer goes back over it, and a location without the marker (back pressed) closes it.
 */
export const usePricesSearchLayerHistory = (options: IUsePricesSearchLayerHistoryOptions): IUsePricesSearchLayerHistoryResult => {
    const {isOpen} = options;
    const history = useHistory();
    const location = useLocation();

    // The layer's own entry is the current one: pushed by this hook and not yet left.
    const isOnLayerEntryRef = useRef(false);
    const isPushedRef = useRef(false);
    const isOpenRef = useRef(isOpen);
    const onCloseRef = useRef(options.onClose);

    useEffect(() => {
        isOpenRef.current = isOpen;
        onCloseRef.current = options.onClose;
    });

    useEffect(() => {
        if (!isOpen || isPushedRef.current) {
            return;
        }

        isPushedRef.current = true;
        const {location: current} = history;
        const state = typeof current.state === "object" && current.state !== null ? current.state : {};
        history.push({...current, state: {...state, [PRICES_SEARCH_LAYER_HISTORY_STATE_KEY]: true}});
    }, [isOpen, history]);

    useEffect(() => {
        // An entry with the marker that this page did not push (a reload of it) is not the layer's.
        if (hasLayerMarker(location.state)) {
            isOnLayerEntryRef.current = isPushedRef.current;
            return;
        }

        if (!isOnLayerEntryRef.current) {
            return;
        }

        // Left the layer's entry: back was pressed, or `close` went back.
        isOnLayerEntryRef.current = false;
        isPushedRef.current = false;
        if (isOpenRef.current) {
            onCloseRef.current();
        }
    }, [location]);

    const close = useCallback(() => {
        onCloseRef.current();

        if (!isPushedRef.current) {
            return;
        }

        // Forgotten first, so the location change `goBack` causes is not taken for a back press.
        isPushedRef.current = false;
        isOnLayerEntryRef.current = false;
        if (hasLayerMarker(history.location.state)) {
            history.goBack();
        }
    }, [history]);

    const leave = useCallback(
        (href: string) => {
            if (isPushedRef.current && hasLayerMarker(history.location.state)) {
                window.location.replace(href);
                return;
            }

            window.location.assign(href);
        },
        [history]
    );

    return {close, leave};
};
